import Image from "next/image";
import Container from "../Container";

export const TEAM = [
  {
    name: "Philip",
    image: "/philip.png",
    linkedin: "https://www.linkedin.com/in/philip-pinckaers-1604b3192/"
  },
  {
    name: "Hendrik",
    image: "/hendrik.png",
    linkedin: "https://www.linkedin.com/in/hendrik-grondijs-01544117/"
  },
  {
    name: "Louis",
    image: "/louis.png",
    linkedin: "https://www.linkedin.com/in/louis-vetter/"
  },
  {
    name: "Annabel",
    image: "/annabel.png",
    linkedin: "https://www.linkedin.com/in/annabel-smith-4a9271261/"
  }
];

export default function About() {
  return (
    <section
      id="about"
      className="pt-12 md:pt-16 pb-20 md:pb-28 relative overflow-hidden"
    >
      {/* Decorative gradient orb */}
      {/* <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-gradient-to-br from-info/15 to-mathorange/15 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -top-20 -left-20 w-64 h-64 bg-gradient-to-br from-mathyellow/10 to-info/10 rounded-full blur-3xl pointer-events-none" /> */}

      <Container>
        <div className="max-w-4xl mx-auto">
          {/* Story section */}
          <div className="text-center mb-10">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-tight mb-6">
              Onze missie
            </h2>

            <div className="max-w-2xl mx-auto space-y-6 text-left">
              {/* Waarom WisWiz? */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Bijles voor iedereen, overal ter wereld
                </h3>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  Talent komt tot bloei onder persoonlijke begeleiding. Zo had
                  Alexander de Grote les van Aristoteles, die op zijn beurt
                  leerling was van Plato. In de klas is daar helaas te weinig
                  ruimte voor. Met innovatieve technologie willen we daarom deze
                  persoonlijke begeleiding mogelijk maken voor iedereen ter
                  wereld. We beginnen met wiskunde: het vak waar leerlingen het
                  vaakst vastlopen; een toren van opbouwende kennis die omvalt
                  zodra een stevig fundament ontbreekt.
                </p>
              </div>

              {/* Over ons */}
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Over ons
                </h3>

                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  WisWiz is opgericht door Philip en Louis, wiskundestudenten
                  aan de TU Delft met jarenlange bijleservaring. We liepen
                  steeds meer tegen de limiet aan dat we met individuele
                  bijlessen te weinig mensen konden helpen. Samen met Hendrik,
                  afgestudeerd statisticus en software ontwikkelaar, zijn we
                  daarom de WisWiz app gaan bouwen. Met deze groep werken we
                  iedere dag om zoveel mogelijk leerlingen te helpen.
                </p>
              </div>

              {/* Contact */}
              <div>
                <p className="text-base md:text-lg text-gray-700 leading-relaxed">
                  We horen graag van je. Of je nu vastloopt, een suggestie hebt
                  of wilt meehelpen aan WisWiz. Bel of WhatsApp ons op{" "}
                  <a
                    href="tel:+31630231640"
                    className="font-bold text-info hover:text-info/80 transition-colors"
                  >
                    06 30 23 16 40
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>

          {/* Team - 1x4 row */}
          <div className="grid grid-cols-4 gap-3 max-w-xl mx-auto">
            {TEAM.map((member) => (
              <a
                key={member.name}
                href={member.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white rounded-lg shadow-sm p-2 md:p-3 text-center transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-info/40 aspect-square flex flex-col items-center justify-center"
                aria-label={`LinkedIn van ${member.name}`}
              >
                <div className="relative w-12 h-12 md:w-14 md:h-14 mx-auto mb-2 overflow-hidden rounded-full">
                  <div className="absolute inset-0 rounded-full border-2 border-info"></div>
                  <Image
                    src={member.image}
                    alt={member.name}
                    width={56}
                    height={56}
                    className="rounded-full object-contain p-1 w-full h-full"
                  />
                </div>
                <h4 className="text-xs md:text-sm font-bold text-gray-800">
                  {member.name}
                </h4>
                <div
                  className="mt-1 flex items-center justify-center"
                  aria-hidden
                >
                  <span className="inline-flex items-center text-info p-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-3.5 h-3.5 md:w-4 md:h-4"
                    >
                      <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.141c-.966 0-1.75-.79-1.75-1.766s.784-1.767 1.75-1.767 1.75.791 1.75 1.767-.783 1.766-1.75 1.766zm13.5 11.141h-3v-5.604c0-1.336-.027-3.055-1.861-3.055-1.861 0-2.146 1.453-2.146 2.955v5.704h-3v-10h2.879v1.367h.041c.401-.76 1.379-1.561 2.84-1.561 3.04 0 3.6 2.003 3.6 4.609v5.585z" />
                    </svg>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}
